export const REFERRALS_ENABLED = false

// Optional approval-card and post-payment tour shortcuts remain disabled.
// The Guide sidebar entry and route are enabled independently of this flag.
export const GUIDE_ENABLED = false
